import { render } from "./ComDeleteButton.vue?vue&type=template&id=19a7a902&ts=true"
import script from "./ComDeleteButton.vue?vue&type=script&lang=ts"
export * from "./ComDeleteButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__